import type { Prototype } from "../prototype-types";

export const quinnBudanPrototypes: Prototype[] = [
  {
    id: "qb-brand-page-samples-placement",
    name: "Brand Page Samples Placement",
    path: "/qb/brand-page-samples-placement",
    description:
      "Explore alternatives to the top-of-brand-page samples carousel: left nav section (list), carousel in Previously Ordered, in-grid carousel, and sampled badges sorted to top — with compact (3) vs expanded (15) density.",
    owner: "Quinn Budan",
    createdAt: "2026-08-08",
    lastUpdated: "2026-08-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ae78dabfb09f0457fc9e169d88768ff8cca0c3c03ee62b831a863409e173ecb3.png",
    creationTool: "cursor",
  },
  {
    id: "qb-brand-search-carousel",
    name: "Brand Page — Products From Your Search",
    path: "/qb/brand-search-carousel",
    description:
      "Brand page with a 'products from your search' carousel for retailers evaluating a new-to-them brand. Flip layout (V3 vs. bottom-up sidebar nav), carousel on/off, and carousel placement (above / after row 1 / 2 / 5). Mid-grid reviews preview simulates infinite-scroll content.",
    owner: "Quinn Budan",
    createdAt: "2026-06-28",
    lastUpdated: "2026-07-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/af08fa62ba1d77294c000bf8043390774e6d65e7d61bf1967f0bb481c87916a3.png",
    creationTool: "claude-code",
  },
  {
    id: "qb-reorder-building-by-brand",
    name: "[Reorder Hub] Reorder Building by Brand",
    path: "/qb/reorder-building-by-brand",
    description: "",
    owner: "Quinn Budan",
    createdAt: "2026-05-08",
    lastUpdated: "2026-05-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/605e9705e05be49694987df47c684954ea67bf16e8d5c6e35ff0cdfed3d3d20c.png",
    creationTool: "cursor",
  },
  {
    id: "qb-journey-aware-pdp",
    name: "Journey Aware PDP",
    path: "/qb/journey-aware-pdp",
    description:
      "Current vs. end-state PDP recommendations for Buy Mode PDP, following the backend carousel rules. Retailer cohorts (new to Faire, never ordered from brand, ordered from brand) with Faire Source, women's apparel preorder, eco-friendly and collection toggles, on desktop web, mobile web and the mobile app.",
    owner: "Quinn Budan",
    createdAt: "2026-10-25",
    lastUpdated: "2026-10-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    project: "Journey Aware PDP Recs",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4cf1af6e2072a8d8e0845b7c0604640c2d1e548399810314a0758efdccabd34e.png",
  },
];
